import { SHIELD_STARTER } from "@static/staticConstents";
import { get } from "lodash";

function generateSqsQuotationRequest(
  whomToBuy: string,
  selectedPlan: string,
  promoCode?: string,
  singpassUserObject?: Object,
  campaignCode?: string
) {
  const body: any = {
    loginId: "QnB",
    requestType: "INIT",
    personType: "",
    proposalType: "TP",
    lifeprofiles: [
      {
        gender: "M",
        smoker: "N",
        dob: "28122008",
        age: 15,
        type: "life-assured",
      },
      {
        smoker: "N",
        gender: "F",
        dob: "28021989",
        relationshipName: "Parent",
        relationshipId: "2",
        name: "AS000",
        type: "assured",
        age: 32,
      },
    ],
    isBIStacking: false,
    coverages: [
      {
        id: "shieldBasic",
        type: "P",
        attributes: { promoCodeSummary: "", campaign_code: campaignCode },
      },
      { attributes: {}, id: "shieldBasicRider", type: "R" },
      { attributes: {}, id: "mediShieldLife", type: "R" },
    ],
    backdate: "",
    deviceos: "",
  };

  const basePlanOnly = selectedPlan === SHIELD_STARTER ? true : false;

  if (whomToBuy === "child") {
    body.personType = whomToBuy;
  } else {
    body.proposalType = "LA";
    body.personType = whomToBuy;
  }

  if (singpassUserObject) {
    const selectedChildData: any = get(
      singpassUserObject,
      "selectedChildInfo",
      null
    );
    const personalInfo: any = get(singpassUserObject, "personalInfo", null);
    body.requestType = "";
    if (personalInfo.customerId) {
      body.customerId = personalInfo.customerId;
    }
    if (whomToBuy === "child") {
      body.lifeprofiles = [
        {
          gender:
            selectedChildData?.gender === "MALE"
              ? "M"
              : selectedChildData?.gender === "FEMALE"
              ? "F"
              : "",
          smoker: "N",
          dob: selectedChildData?.dateOfBirth.split("-").reverse().join(""),
          age: selectedChildData?.age || 0,
          type: "life-assured",
        },
        {
          smoker: "N",
          gender:
            personalInfo?.gender === "MALE"
              ? "M"
              : personalInfo?.gender === "FEMALE"
              ? "F"
              : "",
          dob: personalInfo?.dateOfBirth.split("-").reverse().join(""),
          relationshipName: "Parent",
          relationshipId: "2",
          name: "AS000",
          type: "assured",
          age: personalInfo?.age || 0,
        },
      ];
    } else {
      body.lifeprofiles = [
        {
          gender:
            personalInfo?.gender === "MALE"
              ? "M"
              : personalInfo?.gender === "FEMALE"
              ? "F"
              : "",
          smoker: "N",
          dob: personalInfo?.dateOfBirth.split("-").reverse().join(""),
          age: personalInfo?.age || 0,
          type: "assured",
          staff: "Non-Staff",
        },
      ];
    }
  }

  if (basePlanOnly) {
    body.coverages = body.coverages.filter(
      (x: { id: string }) => x.id !== "shieldBasicRider"
    );
  }
  if (promoCode) {
    body.coverages[0].attributes.promoCodeSummary = promoCode;
  }
  return body;
}
export default generateSqsQuotationRequest;
